import { useCardGridLayout } from '../../context/CardGridLayoutContext';
import { clampColumns, clampTableHeight } from '../../utils/cardGridLayout';
import './CardGridLayoutControl.css';

function NumericStepper({ label, value, onChange, min, max, step = 1, unit = '' }) {
  const clamp = (next) => {
    const parsed = Number.parseInt(String(next), 10);
    if (!Number.isFinite(parsed)) return value;
    return Math.min(max, Math.max(min, parsed));
  };

  const decrease = () => onChange(clamp(value - step));
  const increase = () => onChange(clamp(value + step));

  const onInput = (event) => {
    const next = event.target.value;
    if (next === '') return;
    onChange(clamp(next));
  };

  return (
    <div className="card-grid-layout-control__group" role="group" aria-label={label}>
      <span className="card-grid-layout-control__label">{label}</span>
      <div className="card-grid-layout-control__stepper">
        <button
          type="button"
          className="card-grid-layout-control__btn"
          onClick={decrease}
          disabled={value <= min}
          aria-label={`Decrease ${label}`}
        >
          −
        </button>
        <input
          type="number"
          className="card-grid-layout-control__input"
          min={min}
          max={max}
          step={step}
          value={value}
          onChange={onInput}
          aria-label={`${label}${unit ? ` in ${unit}` : ''}`}
        />
        {unit ? <span className="card-grid-layout-control__unit">{unit}</span> : null}
        <button
          type="button"
          className="card-grid-layout-control__btn"
          onClick={increase}
          disabled={value >= max}
          aria-label={`Increase ${label}`}
        >
          +
        </button>
      </div>
    </div>
  );
}

export default function CardGridLayoutControl() {
  const {
    kpiColumns,
    tableColumns,
    tableHeight,
    setKpiColumns,
    setTableColumns,
    setTableHeight,
    minColumns,
    maxColumns,
    minTableHeight,
    maxTableHeight,
    tableHeightStep,
  } = useCardGridLayout();

  return (
    <div
      className="card-grid-layout-control"
      title="Layout controls — drag cards to reorder on the page"
    >
      <NumericStepper
        label="Metrics"
        value={kpiColumns}
        onChange={(next) => setKpiColumns(clampColumns(next, kpiColumns))}
        min={minColumns}
        max={maxColumns}
        step={1}
      />
      <NumericStepper
        label="Tables"
        value={tableColumns}
        onChange={(next) => setTableColumns(clampColumns(next, tableColumns))}
        min={minColumns}
        max={maxColumns}
        step={1}
      />
      <NumericStepper
        label="Height"
        value={tableHeight}
        onChange={(next) => setTableHeight(clampTableHeight(next, tableHeight))}
        min={minTableHeight}
        max={maxTableHeight}
        step={tableHeightStep}
        unit="px"
      />
    </div>
  );
}
